import { render, staticRenderFns } from "./distributor_page.vue?vue&type=template&id=00dddad8"
import script from "./distributor_page.vue?vue&type=script&lang=js"
export * from "./distributor_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports